//path src/components/assets/AssetsList.js

import React, { useEffect, useState } from 'react';
import { translate } from 'react-i18next';
import { formatAmount } from '../../utils/additional-functions/format-amount.js';
import { formatQuantity } from '../../utils/additional-functions/format-quantity.js';

import AssetsListHeader from 'components/assets/AssetsListHeader';
import AssetsFilters from 'components/assets/AssetsFilters';
import AssetsTable from 'components/assets/AssetsTable';
import * as Common from 'common/components';
import { createRoute } from 'lib/util';
import AssetsFiltersButton from './form_sections/AssetsFiltersButton';
const { Form } = Common;

const AssetsList = ({
  assets,
  accounts,
  costCenters,
  employees,
  locations,
  providers,
  projects,
  physicalState,
  status,
  children,
  companyId,
  count,
  filters,
  handleExport,
  handleExportXLSX,
  handleFiltersChange,
  handleFiltersSubmit,
  handleLimitChange,
  handleOrderChange,
  handlePageChange,
  isLoading,
  pagination,
  permissions,
  subcompanyId,
  handleToggleSearch,
  handleExactSearch,
  columnSearch,
  t,
}) => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [totalMoney, setTotalMoney] = useState(null);
  const [totalMoneyPerFilter, setTotalMoneyPerFilter] = useState(null);
  const [totalDocsPerFilter, setTotalDocsPerFilter] = useState(null);

  useEffect(() => {
    if (assets.length > 0) {
      setTotalMoney(assets[0].totalMoney);
      setTotalMoneyPerFilter(assets[0].totalMoneyPerFilter);
      setTotalDocsPerFilter(assets[0].totalDocsPerFilter);
    }
  }, [assets]);

  return (
    <Common.Wrapper fluid={true}>
      <div className="col-12">
        <Common.Portlet
          title={t('assets.subtitle')}
          icon={'qrcode'}
          button={<AssetsFiltersButton setIsCollapsed={setIsCollapsed} isCollapsed={isCollapsed} />}
          buttonTwo={
            <div className="btn-group pull-right d-flex flex-row">
              {permissions['acl.assets.add'] && (
                <Form.Link
                  to={createRoute(companyId, subcompanyId, 'assets/add')}
                  className="btn btn-info"
                >
                  {t('actions.add')}
                </Form.Link>
              )}
              <Common.Dropdown>
                <Common.DropdownElement onClick={handleExportXLSX}>
                  <i className="fa fa-file-excel-o mr-1" />
                  {t('actions.exportXLSX')}
                </Common.DropdownElement>
                <Common.DropdownElement onClick={handleExport}>
                  <i className="fa fa-table mr-1" />
                  {t('actions.exportCSV')}
                </Common.DropdownElement>
              </Common.Dropdown>
            </div>
          }
          filter={
            <Form.FieldInput
              autoFocus={true}
              name={'fulltext'}
              label={t('actions.search')}
              placeholder={t('actions.search')}
              handleChange={handleFiltersChange}
              t={t}
              value={filters.fulltext}
            />
          }
        >
          <br />
          <h5 className="mb-3">
            {t('assets.subtitle_monts_and_records_assets')}
            <span
              className="info-icon"
              data-tooltip={t('info.tooltip.asset_module.sum_of_amounts_and_records')}
            >
              <i className="fa fa-info-circle"></i>
            </span>
          </h5>
          <div className="mb-3">
            <div className="statsContainer">
              <div className="totalContainer">
                <h6>{t('assets.amount_and_assets_per_page')}</h6>
                <strong>{t('assets.totalMoney')}:</strong>{' '}
                {totalMoney ? `$ ${formatAmount(totalMoneyPerFilter)}` : 'N/A'}
                <br />
                <strong>{t('assets.totalCount')}:</strong> {formatQuantity(totalDocsPerFilter)}
              </div>
              <div className="totalContainer">
                <h6>{t('assets.amount_and_record_of_all_assets')}</h6>
                <strong>{t('assets.totalMoney')}:</strong>{' '}
                {totalMoney ? `$ ${formatAmount(totalMoney)}` : 'N/A'}
                <br />
                <strong>{t('assets.totalCount')}:</strong> {formatQuantity(pagination.totalDocs)}
              </div>
            </div>
          </div>
          <AssetsFilters
            isCollapsed={isCollapsed}
            accounts={accounts}
            employees={employees}
            locations={locations}
            providers={providers}
            projects={projects}
            physicalState={physicalState}
            costCenters={costCenters}
            status={status}
            handleSubmit={handleFiltersSubmit}
            handleValueChange={handleFiltersChange}
            values={filters}
            handleToggleSearch={handleToggleSearch}
            handleExactSearch={handleExactSearch}
            columnSearch={columnSearch}
          />

          <div className="mb-2" style={{ position: 'relative' }}>
            <AssetsTable
              company={{ id: companyId }}
              subcompany={{ id: subcompanyId }}
              permissions={permissions}
              count={count}
              orderBy={pagination.orderBy}
              order={pagination.order}
              handleOrderChange={handleOrderChange}
            >
              {children}
            </AssetsTable>
            <Common.LoaderOverlay show={isLoading} />
          </div>

          <Common.Pagination
            {...pagination}
            handleLimitChange={handleLimitChange}
            handlePageChange={handlePageChange}
          />
        </Common.Portlet>
      </div>
    </Common.Wrapper>
  );
};

export default translate()(AssetsList);



// WEBPACK FOOTER //
// src/components/assets/AssetsList.js